import { FULFILL_UNIT_TYPE } from './fulfill.constants';
import { buildBatchesFromValues } from './batchFields';

// What the form has committed so far, so General details can count it down live.

const total = (entries, key) =>
  entries.reduce((sum, entry) => sum + (Number(entry?.[key]) || 0), 0);

/**
 * The amounts already entered, in the row's own unit — `null` where the form is working in a
 * different one, since a figure under the wrong unit is worse than no figure.
 */
export const enteredQuantities = ({ unit, unitType, values = {}, assigned }) => {
  const assignedMatchesRow = values.shipmentQuantityUnit === unit;
  const batchesMatchRow = values.fulfillUnitType === FULFILL_UNIT_TYPE[unitType];

  return {
    assigned: assignedMatchesRow ? Number(assigned ?? values.assignedQuantity) || 0 : null,
    allocated: batchesMatchRow ? total(buildBatchesFromValues(values), 'certifiedQuantity') : null,
  };
};

/** `remaining - entered`, floored at 0; `remaining` untouched when nothing comparable was entered. */
export const remainingAfterEntry = (remaining, entered) =>
  remaining == null || entered == null ? remaining : Math.max(0, remaining - entered);

/** `committed + entered` — the other side of remainingAfterEntry, so a pair always moves together. */
export const addedAfterEntry = (committed, entered) =>
  committed == null || entered == null ? committed : committed + entered;
